




































import { Component, Vue, Prop } from "vue-property-decorator";
import FinancialStatementTips from './FinancialSettlementTips.vue'

@Component({
  name: "statementAccountInfo",
  components: {
    FinancialStatementTips
  },
})
export default class extends Vue {
  @Prop({ default: () => ({}) }) private item!: any;
  @Prop({ default: true }) private showTips!: any;
}
